// Syntactic sugar for remapping an objects keys and values (with the same transform)
export function mapRecord(record: Record<string, string>, fn: (str: string) => string) {
  return Object.fromEntries(Object.entries(record).map(([key, value]) => [fn(key), fn(value)]));
}
